import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive", "orderDir"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { pxToRem, getBackgroundShade } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import { Arrow as ArrowIcon } from 'components/icons';
import ButtonCore from 'components/ButtonCore';
import VisuallyHidden from 'components/VisuallyHidden';
import { getColumnName } from '../../utils';
var Wrapper = styled.span.withConfig({
  displayName: "ClickableHeader__Wrapper",
  componentId: "sc-dkvbfi-0"
})(["vertical-align:baseline;padding-right:", ";"], function (p) {
  return p.theme.globals.spacing.xxs;
});
var shouldForwardProp = function shouldForwardProp(prop) {
  return !['isActive', 'isSortable'].includes(prop);
};
var ClickabilityIndicator = styled(ButtonCore).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "ClickableHeader__ClickabilityIndicator",
  componentId: "sc-dkvbfi-1"
})(["margin-left:", ";vertical-align:0;&::before{content:'';position:absolute;width:", ";height:", ";margin-top:", ";margin-left:", ";background-color:currentcolor;border-radius:50%;opacity:", ";transition:opacity 0.15s ease-in-out 0.15s;}&:hover::before,&.focus-visible::before{opacity:0;transition-delay:0s;}&::after{content:'';", "}"], function (p) {
  return p.theme.globals.spacing.xxs;
}, pxToRem(4), pxToRem(4), pxToRem(8), pxToRem(5), function (p) {
  return p.isActive ? 0 : 0.5;
}, fillParent);
var StyledSortArrow = styled(ArrowIcon).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "ClickableHeader__StyledSortArrow",
  componentId: "sc-dkvbfi-2"
})(["border-radius:50%;transition-property:all;", " ", ":hover &&,", ".focus-visible &&{fill:", ";opacity:1;transition-delay:0.15s;background-color:", ";box-shadow:0 0 0 3px ", ";}"], function (p) {
  return !p.isActive && css(["opacity:0;"]);
}, ClickabilityIndicator, ClickabilityIndicator, function (p) {
  return p.theme.links;
}, function (p) {
  return getBackgroundShade(p.theme);
}, function (p) {
  return getBackgroundShade(p.theme);
});
function SortArrow(_ref) {
  var isActive = _ref.isActive,
    orderDir = _ref.orderDir,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ClickabilityIndicator, _extends({}, otherProps, {
    isActive: isActive
  }), /*#__PURE__*/React.createElement(StyledSortArrow, {
    vAlign: true,
    dimmed: true,
    isActive: isActive,
    scale: 0.8,
    rotate: orderDir === 'desc' ? -90 : 90
  }));
}
var reverseOrder = {
  asc: 'desc',
  desc: 'asc'
};
var orderLabels = {
  asc: 'sortedAsc',
  desc: 'sortedDesc'
};
function ClickableHeader(_ref2) {
  var isActive = _ref2.isActive,
    column = _ref2.column,
    order = _ref2.order,
    a11yLabels = _ref2.a11yLabels,
    onRequestSort = _ref2.onRequestSort,
    children = _ref2.children;
  var columnName = getColumnName(column);

  // Only flip the order when the column to be ordered by doesn't change.
  // Otherwise use the column's `defaultOrder` prop
  var newOrder = isActive && order ? reverseOrder[order] : column.defaultOrder || 'asc';
  function getSortHandler() {
    if (typeof onRequestSort !== 'function') return null;
    return function () {
      onRequestSort({
        column: column.name || column.title,
        order: newOrder
      });
    };
  }
  return /*#__PURE__*/React.createElement(Wrapper, null, children, isActive && order && /*#__PURE__*/React.createElement(VisuallyHidden, null, "(".concat(a11yLabels[orderLabels[order]], ")")), /*#__PURE__*/React.createElement(SortArrow, {
    isActive: isActive,
    orderDir: isActive ? order : column.defaultOrder,
    onClick: getSortHandler(),
    "aria-label": a11yLabels.sortByColumn(columnName, newOrder)
  }));
}
export default ClickableHeader;